<script>
		import { user } from "../client.svelte.js";
		import { narrate } from "./_Narrate.svelte";

		let fshp = view.fellowship
		let survey = $state(view.fellowship.survey)
		// $inspect(`SURVEY - fellowship`, fshp)

		/** highest value of a row (0 if no hero has the skill) **/
		const max_of = (values) => Math.max(0, ...values)

		/** average of the non-zero values of a row (German number format) **/
		function average(values) {
				const set = values.filter(v => v)
				return set.length ? (set.reduce((sum, v) => sum + v, 0) / set.length).toLocaleString('de-DE', {maximumFractionDigits: 1}) : ""
		}

		async function view_hero(e) {
			if (user.ID !== fshp.admin)  return
			await view.select_character(this.ID)
			view.switch_layout("hero-abils")
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<article class="overview">
	<div>
		<h2 class="page-title">Übersicht der {fshp?.name ?? ""}-Gruppe</h2>
		<p class="card-meta">Fertigkeitswerte aller Helden der Gruppe. Der höchste Wert je Zeile ist hervorgehoben, Ø ist der Mittelwert der Helden mit dieser Fertigkeit.</p>
	</div>
	{#if !fshp}
		<p class="card-meta">Bitte wähle zuerst in der Gruppenübersicht eine Gruppe aus.</p>
	{:else if !survey}
		<p class="card-meta">Die Fertigkeiten werden geladen …</p>
	{:else if survey.heroes.length === 0}
		<p class="card-meta">Diese Gruppe hat noch keine Helden.</p>
	{:else}
		<div class="tableFrame">
			<table class="skillTable">
				<thead>
					<tr>
						<th class="nameCol">Charakter</th>
						{#each survey.heroes as hero (hero.ID)}
							<th class="valCol" title={hero.ID} onclick={view_hero.bind(hero)}>
								<div>{hero.name}</div>
								<div class="owner">{hero.owner}</div>
							</th>
						{/each}
						<th class="valCol avgCol" title="Mittelwert der Helden mit dieser Fertigkeit">Ø</th>
					</tr>
				</thead>
				<tbody>
					{#each survey.cats as cat (cat.name)}
						<tr class="catRow">
							<td colspan={survey.heroes.length + 2}><span>{cat.name}</span></td>
						</tr>
						{#each cat.rows as row (row.ID)}
							{@const max = max_of(row.values)}
							<tr>
								<td class="nameCol">{row.name}</td>
								{#each row.values as value, i (i)}
									<td class="valCol" class:best={value && value === max}>{(value > 0) ? value : ""}</td>
								{/each}
								<td class="valCol avgCol">{average(row.values)}</td>
							</tr>
						{/each}
					{/each}
				</tbody>
			</table>
		</div>
	{/if}
</article>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	/* the table frame (not the page) scrolls vertically, so that the table head can stick to its top */
	.overview
		min-height: 0
		overflow: hidden

	.tableFrame
		flex: 0 1 auto
		min-height: 0
		max-width: 100%
		overflow-x: auto
		overflow-y: scroll
		scrollbar-width: thin
		scrollbar-color: colors.$grey-30 transparent

	.skillTable
		width: auto
		min-width: 420px
		border-collapse: collapse
		font-size: 14px

		th, td
			padding: 6px 8px

		th
			text-align: left
			font-size: 11px
			letter-spacing: .08em
			text-transform: uppercase
			color: colors.$grey-60
			line-height: 1.25

		/* sticky table head: a border would scroll away with collapsed borders, hence the inset shadow */
		thead th
			position: sticky
			top: 0
			z-index: 2
			background: colors.$black
			box-shadow: inset 0 -1px 0 colors.$grey-30

			&.nameCol
				z-index: 3

			&.avgCol
				background: colors.$grey-15

		tbody tr:not(.catRow)
			border-bottom: 1px solid colors.$grey-20

			&:hover td
				background-color: colors.$grey-15

	.nameCol
		position: sticky
		left: 0
		z-index: 1
		min-width: 22ch
		background: colors.$black
		color: colors.$grey-85

	.valCol
		min-width: 9ch
		text-align: center !important
		font-variant-numeric: tabular-nums
		color: colors.$grey-85

		&.best
			color: colors.$primary-100
			font-weight: 500

	.owner
		font-size: 11px
		font-weight: normal
		text-transform: none
		letter-spacing: 0
		color: colors.$grey-50

	/* separated average column */
	.avgCol
		border-left: 2px solid colors.$grey-30
		background: colors.$grey-15
		color: colors.$grey-60
		font-style: italic

	th.avgCol
		font-size: 14px
		font-style: normal

	.catRow td
		padding: 24px 12px 6px
		background: colors.$black
		border-bottom: 1px solid colors.$primary-060-black

		span
			position: sticky
			left: 12px
			font-size: 12px
			font-weight: 500
			letter-spacing: .08em
			text-transform: uppercase
			color: colors.$primary-100
</style>
